import Bestellung from "@/entities/common/bestellung"
import RemoteResult from "@/entities/common/remote_result"
import ServiceAnfordernRequest from "@/entities/common/request/service_anfordern_request"
import router from "@/router"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import BaseLogic from "../base_logic"
import MainLogic from "../main_logic"

export default class ServiceAnfordernLogic extends BaseLogic {
  bestellung?: Bestellung = null
  kommentare?: string = null
  rechnungAnfordern: boolean = false

  init() {
    this.bestellung = this.mainLogic.bestellung
  }

  absenden() {
    var request = new ServiceAnfordernRequest()
    request.bestellungId = this.bestellung.id
    request.kommentare = this.kommentare
    request.rechnungAnfordern = this.rechnungAnfordern

    Poster.postUser<RemoteResult<any>>(
      RestPaths.bestellungKundeServiceAnfordern,
      request
    ).then((response) => {
      if (response.data.success) {
        router.go(-1)
      }
    })
  }
}
